<script setup>
import { computed, defineProps } from 'vue';
import { useStore } from 'vuex'

const props = defineProps({
   apprehension: {
    type: [Object, null],
    required: true
   },
   company: {
    type: String,
    required: true
   }
});

const store = useStore();

const loading = computed(() => store.state.globals.loading);
</script>

<template>
<b-overlay :show="loading">
    <div class="p-3">
        <table class="table table-bordered table-sm table-light">
            <tbody v-if="!props.apprehension.has_alarm && !props.apprehension.has_lift">
                <tr>
                    <th class="text-center">{{ props.company }}</th>
                </tr>
                <tr>
                    <td class="text-center">No upload / lift apprehension record yet!</td>
                </tr>
            </tbody>
            <tbody v-else-if="props.apprehension.has_alarm && props.apprehension.has_lift">
                <tr>
                    <th colspan="2" class="text-center">{{ props.company }}</th>
                </tr>
                <tr>
                    <td class="text-center">Status</td>
                    <td class="text-center">{{ props.apprehension.alarm.status ? props.apprehension.alarm.status : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">MV File No.</td>
                    <td class="text-center">{{ props.apprehension.alarm.mv_file_number ? props.apprehension.alarm.mv_file_number : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Plate No.</td>
                    <td class="text-center">{{ props.apprehension.alarm.plate_number ? props.apprehension.alarm.plate_number : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Conduction Sticker</td>
                    <td class="text-center">{{ props.apprehension.alarm.conduction_sticker_number ? props.apprehension.alarm.conduction_sticker_number : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Upload Schedule</td>
                    <td class="text-center">{{ props.apprehension.alarm.upload_schedule ? props.apprehension.alarm.upload_schedule : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Upload Date Executed</td>
                    <td class="text-center">{{ props.apprehension.alarm.upload_date_executed ? props.apprehension.alarm.upload_date_executed : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Violation Code</td>
                    <td class="text-center">{{ props.apprehension.alarm.violation_code ? props.apprehension.alarm.violation_code : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Violation Description</td>
                    <td class="text-center">{{ props.apprehension.alarm.violation_description ? props.apprehension.alarm.violation_description : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Apprehension Date</td>
                    <td class="text-center">{{ props.apprehension.alarm.apprehension_date ? props.apprehension.alarm.apprehension_date : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Apprehending Officer</td>
                    <td class="text-center">{{ props.apprehension.alarm.apprehending_officer ? props.apprehension.alarm.apprehending_officer : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Transaction ID</td>
                    <td class="text-center">{{ props.apprehension.alarm.transaction_id ? props.apprehension.alarm.transaction_id : 'n/a' }}</td>
                </tr>
                <tr>
                    <th colspan="2" class="text-center">Lift Apprehension</th>
                </tr>
                <tr>
                    <td class="text-center">Transaction ID</td>
                    <td class="text-center">{{ props.apprehension.lift.transaction_id ? props.apprehension.lift.transaction_id : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">OR No.</td>
                    <td class="text-center">{{ props.apprehension.lift.or_number ? props.apprehension.lift.or_number : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Amount</td>
                    <td class="text-center">{{ props.apprehension.lift.amount ? props.apprehension.lift.amount : 'n/a' }}</td>
                </tr>
                 <tr>
                    <td class="text-center">Date Settled</td>
                    <td class="text-center">{{ props.apprehension.lift.date_settled ? props.apprehension.lift.date_settled : 'n/a' }}</td>
                </tr>
            </tbody>
            <tbody v-else-if="props.apprehension.has_alarm && !props.apprehension.has_lift">
                <tr>
                    <th colspan="2" class="text-center">{{ props.company }}</th>
                </tr>
                <tr>
                    <td class="text-center">Status</td>
                    <td class="text-center">{{ props.apprehension.alarm.status ? props.apprehension.alarm.status : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">MV File No.</td>
                    <td class="text-center">{{ props.apprehension.alarm.mv_file_number ? props.apprehension.alarm.mv_file_number : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Plate No.</td>
                    <td class="text-center">{{ props.apprehension.alarm.plate_number ? props.apprehension.alarm.plate_number : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Conduction Sticker</td>
                    <td class="text-center">{{ props.apprehension.alarm.conduction_sticker_number ? props.apprehension.alarm.conduction_sticker_number : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Upload Schedule</td>
                    <td class="text-center">{{ props.apprehension.alarm.upload_schedule ? props.apprehension.alarm.upload_schedule : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Upload Date Executed</td>
                    <td class="text-center">{{ props.apprehension.alarm.upload_date_executed ? props.apprehension.alarm.upload_date_executed : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Violation Code</td>
                    <td class="text-center">{{ props.apprehension.alarm.violation_code ? props.apprehension.alarm.violation_code : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Violation Description</td>
                    <td class="text-center">{{ props.apprehension.alarm.violation_description ? props.apprehension.alarm.violation_description : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Apprehension Date</td>
                    <td class="text-center">{{ props.apprehension.alarm.apprehension_date ? props.apprehension.alarm.apprehension_date : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Apprehending Officer</td>
                    <td class="text-center">{{ props.apprehension.alarm.apprehending_officer ? props.apprehension.alarm.apprehending_officer : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Transaction ID</td>
                    <td class="text-center">{{ props.apprehension.alarm.transaction_id ? props.apprehension.alarm.transaction_id : 'n/a' }}</td>
                </tr>
                <tr>
                    <th colspan="2" class="text-center">Lift Apprehension</th>
                </tr>
                <tr>
                    <td colspan="2" class="text-center">No lift apprehension record yet!</td>
                </tr>
            </tbody>
            <tbody v-else-if="!props.apprehension.has_alarm && props.apprehension.has_lift">
                <tr>
                    <th colspan="2" class="text-center">{{ props.company }}</th>
                </tr>
                <tr>
                    <th colspan="2" class="text-center">Lift Apprehension</th>
                </tr>
                <tr>
                    <td class="text-center">Transaction ID</td>
                    <td class="text-center">{{ props.apprehension.lift.transaction_id ? props.apprehension.lift.transaction_id : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">OR No.</td>
                    <td class="text-center">{{ props.apprehension.lift.or_number ? props.apprehension.lift.or_number : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="text-center">Amount</td>
                    <td class="text-center">{{ props.apprehension.lift.amount ? props.apprehension.lift.amount : 'n/a' }}</td>
                </tr>
                 <tr>
                    <td class="text-center">Date Settled</td>
                    <td class="text-center">{{ props.apprehension.lift.date_settled ? props.apprehension.lift.date_settled : 'n/a' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</b-overlay>
</template>

<style scoped>
.no-wrap{
  min-width: fit-content;
  width: 100px;
  white-space: nowrap;
}
th, td {
    background-color: #fff;
}
td{
  padding: 5px;
  text-align: center;
}
</style>
